import React from 'react';
import TermlyEmbed from './TermlyEmbed';

const TermsOfService = () => {
  return <TermlyEmbed dataId="bfaba905-3b80-44c6-aadb-ba01fda339ac" />;
};

export default TermsOfService;
